import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Leader of the Pack",
    "spell_nature_unyeildingstamina",
    [
      "While in Cat, Bear, or Dire Bear Form, the Leader of the Pack increases ranged and melee critical chance of all party members within 45 yards by 3%.",
    ],
    1,
    [[]]
  ),
  null,
  null,
];

export default tier7;
